import React, { useEffect } from 'react';

import { CdkLogo_wht } from '../CdkLogo/CdkLogo';
import Footer from '../footer';
import './index.scss';

import UserInfo from '../userInfo/UserInfo';
import { useSelector, useDispatch } from 'react-redux';
import { Constants } from '../../constants/constants';
import { setConstants } from '../../redux/connectedComponent/solutionInfo/solutionInfo.slice';

const Page = ({ children, HideAppManagementText , pageHeader}) => {
  const state = useSelector(state => state);
  const dispatch = useDispatch();
  const { solutionInfo, isSolutionInfoSuccess } = state.solutionInfoSlice;

  useEffect(() => {
    if (solutionInfo.activateOnly !== false)
      dispatch(setConstants(Constants.Activation));
    else
      dispatch(setConstants(Constants.Subscription));
  }, [isSolutionInfoSuccess]);

  return (
    <div className="page-container">
      <div className="page-header-container">
        <div className='page-header-subcontainer'>
        <CdkLogo_wht className="page-header-logo" />
       {!HideAppManagementText ? <div className="global-header-section-divider"></div> : null }
           <div className="gobal-header-section-app-management">{!HideAppManagementText ? pageHeader : ''}</div>
        </div>
        <div className="global-header-section-userinfo">
          <UserInfo email={state.loginDetailsSlice.userEmail} />
        </div>
      </div>
      <div className="page-body-container">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Page;
